export class ExternalSystem {
  externalSystemId?: number;
  clientITProfileId?: number;
  number?: string;
  name?: string;
  connectionDetails?: string;
  nature?: string;
  isSupported?: boolean;
  dataTypes?: string;
  dataCategorization?: string;
  users?: string;
  otherPrograms?: string;
  description?: string;
  hostingEnvironment?: string;
  riskImpactMitigation?: string;
}
